<div class="nt-lap">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Naptártípusok</ion-card-title>
      <ion-card-subtitle>
        Program, szünet, ünnepély… — a típus <b>színe</b> és <b>ikonja</b> jelöli az eseményt a naptárban,
        az órarend eseménysávjában és a beágyazott naptárban is.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div *ngIf="toltodik">Betöltés…</div>
      <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>

      <div class="nt-uj" *ngIf="!toltodik">
        <ion-button size="small" fill="outline" (click)="ujNyitva = !ujNyitva">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>Új típus
        </ion-button>
      </div>

      <div class="nt-uj" *ngIf="ujNyitva">
        <ion-input label="Név" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.nev"
                   placeholder="pl. Nyílt nap"></ion-input>
        <label class="nt-szin">Szín<input type="color" [(ngModel)]="uj.szin"></label>
        <ion-input label="Ikon (ionicons név)" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.ikon"
                   placeholder="pl. school" style="max-width:220px"></ion-input>
        <span class="nt-elonezet" [style.background]="uj.szin">
          <ion-icon [name]="ikonElonezet(uj.ikon)"></ion-icon>{{ uj.nev || 'Előnézet' }}
        </span>
        <ion-button size="small" color="success" (click)="ujMent()">
          <ion-icon slot="start" name="save-outline"></ion-icon>Felvétel
        </ion-button>
      </div>

      <div class="nt-tabla-wrap" *ngIf="!toltodik && tipusok.length">
        <table class="nt-tabla">
          <thead>
            <tr>
              <th style="width:70px">Sorrend</th><th>Név</th><th style="width:70px">Szín</th>
              <th style="width:200px">Ikon</th><th>Előnézet</th><th style="width:110px">Használat</th><th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of tipusok" [class.nt-rejtett]="t.rejtett">
              <td><input type="number" [(ngModel)]="t.sorrend" min="0" step="10"></td>
              <td>
                <input type="text" [(ngModel)]="t.nev" maxlength="100">
                <small class="nt-rejtett-jel" *ngIf="t.rejtett">rejtett – új eseményhez nem választható</small>
              </td>
              <td><input type="color" [(ngModel)]="t.szin"></td>
              <td><input type="text" [(ngModel)]="t.ikon" placeholder="pl. school"></td>
              <td>
                <span class="nt-elonezet" [style.background]="t.szin">
                  <ion-icon [name]="ikonElonezet(t.ikon)"></ion-icon>{{ t.nev }}
                </span>
              </td>
              <td>
                <span *ngIf="t.hasznalat">{{ t.hasznalat }} esemény</span>
                <span *ngIf="!t.hasznalat" class="halvany">nincs használva</span>
              </td>
              <td class="muvelet">
                <ion-button size="small" fill="clear" color="success" *ngIf="modosult(t)" (click)="ment(t)" title="Mentés">
                  <ion-icon slot="icon-only" name="save-outline"></ion-icon>
                </ion-button>
                <ion-button size="small" fill="clear" color="medium" (click)="rejtes(t)"
                            [title]="t.rejtett ? 'Megjelenítés – újra választható lesz' : 'Elrejtés – új eseményhez nem választható'">
                  <ion-icon slot="icon-only" [name]="t.rejtett ? 'eye-outline' : 'eye-off-outline'"></ion-icon>
                </ion-button>
                <!-- A letiltott gomb nem kap egér-eseményt, ezért a magyarázat a burkoló címében van. -->
                <span [title]="torlesCim(t)">
                  <ion-button size="small" fill="clear" color="danger" (click)="torol(t)" [disabled]="t.hasznalat > 0">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ion-note color="medium" class="nt-megjegyzes">
        Az <b>ikon</b> az <a href="https://ionic.io/ionicons" target="_blank" rel="noopener">Ionicons</a> készlet
        egy elemének neve (pl. <code>school</code>, <code>bus</code>, <code>trophy</code>); az előnézet mutatja, jó-e.
        A <b>sorrend</b> a naptár típusválasztójában érvényes. <b>Törölni</b> csak a még nem használt típust lehet;
        a használtat <b>elrejtheted</b> — új eseményhez nem választható, a meglévő események nem változnak.
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
